<template>
  <popup
    :close-action="closeActionClicked"
    class="winning-together-popup">
    <template v-slot:title>
      <div class="title">
        את החודש הקרוב אפשר לנצח ביחד!
      </div>
    </template>
    <template v-slot:content>
      <div class="chat-intro">
        <span class="bold">הדר, </span>
        <span>שיתפה עם הקהילה שלנו:</span>
      </div>
      <div>
        <img class="chat-image" :src="require('@/assets/winning-together/chat.svg')" />
      </div>
      <separator/>
      <thumbs class="thumbs" v-on:thumbsup="thumbsUp" v-on:thumbsdown="thumbsDown" question-text="עשה לך טוב לקרוא את זה?" variant="secondary"/>
      <riseup-button title="קחו אותי לקהילה" variant="primary" size="small" :action="takeMeToFacebook"/>
    </template>
  </popup>
</template>

<script>
import BaseUI from 'base-ui';

import Segment from '@/Segment';
import Thumbs from '@/base-components/Thumbs.vue';

export default {
  name: 'WinningTogetherPopup',
  components: {
    Thumbs,
    Popup: BaseUI.Popup,
    RiseupButton: BaseUI.RiseupButton,
    Separator: BaseUI.Separator,
  },
  async created() {
    Segment.trackUserInteraction('WinningTogetherPopupShown');
  },
  methods: {
    closeActionClicked() {
      Segment.trackUserInteraction('WinningTogetherPopupClosed');
      this.$emit('close');
    },
    takeMeToFacebook() {
      Segment.trackUserInteraction('WinningTogetherPopup_TakeMeToFacebookClicked');
      window.open('https://www.facebook.com/groups/riseuptogethergroup', '_blank');
    },
    thumbsUp() {
      Segment.trackUserInteraction('WinningTogetherPopup_ThumbsUp');
    },
    thumbsDown() {
      Segment.trackUserInteraction('WinningTogetherPopup_ThumbsDown');
    },
  },
};

</script>

<style scoped lang="scss">

  @import "~base-ui/src/scss/riseup-colors";

  .winning-together-popup {

    .title {
      padding-left: 10px;
    }

    .bold {
      font-weight: bold;
    }

    .content {
      .chat-intro {
        margin-bottom: 30px;
      }

      .chat-image {
        width: 100%;
      }

      .thumbs {
        margin-top: 30px;
      }

      .separator {
        margin-top: 30px;
      }
    }

    .riseup-button {
      margin-top: 24px;
      width: 100%;
    }

  }

</style>
